import { useState, type MouseEvent } from 'react';
import { ArrowRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLocalSettings } from '@/hooks/use-local-settings';
import { isFoundersOnlyEventActive } from '@/constants/founders-only-event';
import { cn } from '@/lib/utils';
import { FoundersOnlyPromoModal } from './founders-only-promo-modal';
import { FoundersOnlyLogo } from './founders-only-logo';

export function FoundersOnlyPromoCard() {
  const { localSettings, setLocalSettings } = useLocalSettings();
  const [modalOpen, setModalOpen] = useState(false);

  if (
    !isFoundersOnlyEventActive() ||
    localSettings.foundersOnlyPromoDismissed
  ) {
    return null;
  }

  const handleDismiss = (event: MouseEvent) => {
    event.stopPropagation();
    setLocalSettings({
      ...localSettings,
      foundersOnlyPromoDismissed: true,
    });
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        className={cn(
          'group-data-[collapsible=icon]:hidden',
          'relative w-full rounded-lg border border-primary bg-white p-3 text-left transition-colors hover:bg-white/90'
        )}
      >
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1 size-6 text-muted-foreground hover:text-foreground"
          aria-label="Fechar"
          onClick={handleDismiss}
        >
          <X />
        </Button>

        <div className="pr-6">
          <FoundersOnlyLogo />
        </div>

        <p className="mt-1 text-xs text-muted-foreground">
          A Korza vai estar no Founders Only, evento de sala fechada com os
          maiores founders e nomes do e-commerce no Brasil.
        </p>

        <span className="mt-2 flex items-center justify-end gap-1 text-sm text-primary">
          Saiba mais
          <ArrowRight className="size-3.5" />
        </span>
      </button>

      <FoundersOnlyPromoModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
}
